/**
 * View for configuring the KB settings as part of the KB creation wizard
 */
define(["marionette", "messaging/messenger", "./template/kbSettingsTemplate.html"], function (
  Marionette,
  Messenger,
  KbSettingsTemplate,
) {
  "use strict";

  const KbSettingsView = {};

  KbSettingsView.kbSettingsView = Marionette.ItemView.extend({
    template: KbSettingsTemplate,
    events: {
      "click #agentAssist": function () {
        this.trigger("toggle:agent:assist");
      },
      "change #tenant": function () {
        this.trigger("change:tenant");
      },
    },
    templateHelpers: {
      getEngineModeLabel: function (modeValue) {
        return Messenger.reqres.request("kb:engine:mode:label", modeValue);
      },
    },
    getKbName: function () {
      return this.$el.find("#kbName").val().trim();
    },
    getKbDescription: function () {
      return this.$el.find("#kbDescription").val().trim();
    },
    getTenant: function () {
      return parseInt(this.$el.find("#tenant").val());
    },
    getResponseCollaboration: function () {
      return this.$el.find("#responseCollaboration").prop("checked");
    },
    getResponseVersioning: function () {
      return this.$el.find("#responseVersioning").prop("checked");
    },
    getTaskManagement: function () {
      return this.$el.find("#taskManagement").prop("checked");
    },
    getActionGroups: function () {
      return this.$el.find("#actionGroups").prop("checked");
    },
    getAgentAssist: function () {
      return this.$el.find("#agentAssist").prop("checked");
    },
    getAdHocReporting: function () {
      return this.$el.find("#adHocReporting").prop("checked");
    },
    getRecommendations: function () {
      return this.$el.find("#recommendations").prop("checked");
    },
    getCrossTouchPointAccess: function () {
      return this.$el.find("#crossTouchPointAccess").prop("checked");
    },
    getEditSource: function () {
      return this.$el.find("#editSource").prop("checked");
    },
    getAiFeatures: function () {
      return this.$el.find("#aiFeatures").prop("checked");
    },
    getCustomLibrarian: function () {
      return this.$el.find("#customLibrarian").prop("checked");
    },
    getSecureUploadAccess: function () {
      return this.$el.find("#secureUploadAccess").prop("checked");
    },
    getSiteMapAccess: function () {
      return this.$el.find("#siteMapAccess").prop("checked");
    },
    getEngineMode: function () {
      return +this.$el.find("#engineMode").val();
    },
    getResponseReview: function () {
      return this.$el.find("#responseReview").prop("checked");
    },
    getExampleGeneration: function () {
      return this.$el.find("#exampleGeneration").prop("checked");
    },
    kbNameError: function (errorMessage) {
      this.$el
        .find("#kbNameError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    kbDescriptionError: function (errorMessage) {
      this.$el
        .find("#kbDescriptionError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    tenantError: function (errorMessage) {
      this.$el
        .find("#tenantError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    responseCollaborationError: function (errorMessage) {
      this.$el
        .find("#responseCollaborationError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    responseVersioningError: function (errorMessage) {
      this.$el
        .find("#responseVersioningError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    responseReviewError: function (errorMessage) {
      this.$el
        .find("#responseReviewError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    exampleGenerationError: function (errorMessage) {
      this.$el
        .find("#exampleGenerationError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    taskManagementError: function (errorMessage) {
      this.$el
        .find("#taskManagementError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    actionGroupsError: function (errorMessage) {
      this.$el
        .find("#actionGroupsError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    agentAssistError: function (errorMessage) {
      this.$el
        .find("#agentAssistError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    adHocReportingError: function (errorMessage) {
      this.$el
        .find("#adHocReportingError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    recommendationsError: function (errorMessage) {
      this.$el
        .find("#recommendationsError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    crossTouchPointAccessError: function (errorMessage) {
      this.$el
        .find("#crossTouchPointAccessError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    editSourceError: function (errorMessage) {
      this.$el
        .find("#editSourceError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    aiFeaturesError: function (errorMessage) {
      this.$el
        .find("#aiFeaturesError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    customLibrarianError: function (errorMessage) {
      this.$el
        .find("#customLibrarianError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    secureUploadAccessError: function (errorMessage) {
      this.$el
        .find("#secureUploadAccessError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    siteMapAccessError: function (errorMessage) {
      this.$el
        .find("#siteMapAccessError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    engineModeError: function (errorMessage) {
      this.$el
        .find("#engineModeError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("#kbNameError").html("");
      this.$el.find("#kbDescriptonError").html("");
      this.$el.find("#tenantError").html("");
      this.$el.find("#responseVersioningError").html("");
      this.$el.find("#taskManagementError").html("");
      this.$el.find("#actionGroupsError").html("");
      this.$el.find("#agentAssistError").html("");
      this.$el.find("#adHocReportingError").html("");
      this.$el.find("#recommendationsError").html("");
      this.$el.find("#crossTouchPointAccessError").html("");
      this.$el.find("#secureUploadAccessError").html("");
      this.$el.find("#siteMapAccessError").html("");
      this.$el.find("#engineModeError").html("");
    },
  });

  return KbSettingsView;
});
